/*
  <summary>
    This functional component provides functionalities like redirection to other modules, logout & User Profile.
    Developer: Aashish Singh, Created Date: 29-March-2023
  </summary>
  <returns>Returns JSX</returns>
*/
 
import { observer } from "mobx-react";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { NavLink, useHistory } from "react-router-dom";
import monozlogo from "../../assets/Images/logo--white.png";
import { useStore } from "../../contexts/store-provider";
import { getCustomerEmailFromToken, getCustomerNameFromToken, getTokenFromLocalStorage } from "../../helpers/localstorage-helper";
import LogoutPopup from "../../modules/auth/components/logout-popup";
import { formatMessage } from "../../translations/format-message";
import LanguageSlider from "../language-slider/language-slider";
import RoutesConstants from "../routes/routes-constants";
import "./customer-left-navbar.css";
import "./left-navbar.css";
 
 
 
// Main CustomerTopNavBar component
const CustomerTopNavBar = () => {
    const { authStore, bookingManagementStore } = useStore();
    const { setShowLogoutPopup, showLogoutPopup, isAuthenticated } = authStore;
    const history = useHistory();
    return (
        <React.Fragment>
            {/* Popups for settings and user actions */}
 
            {showLogoutPopup && (
                <LogoutPopup modalClosed={() => setShowLogoutPopup(!showLogoutPopup)} />
            )}
 
            <div className="icon-nav navbar-fixed-top device-nav-bar px-3 userTopNav">
                <div className="container-xxl container-fluid px-0 h-100">
                    <div className="row align-items-center h-100">
                        <div className="col-4 col-sm-3 col-md-3 col-lg-2 col-xl-2 col-xxl-2 container-logo">
                            <img
                                src={monozlogo}
                                alt="mono_z_Logo"
                                className="img-fluid"
                            />
                        </div>
                        <div className="col-8 col-sm-9 col-md-9 col-lg-10 col-xl-10 col-xxl-10 text-end">
                            <ul className="d-flex justify-content-end gap-2 align-items-center">
                                <li>
                                    <LanguageSlider />
                                </li>      
                                {(isAuthenticated || bookingManagementStore.isAuthenticated || getTokenFromLocalStorage() !== "") ? (
                                    <li>
                                        <a
                                            href="#"
                                            data-bs-toggle="dropdown"
                                            className="dropdown-toggle m-0 header_profile_dropdown"
                                        >
                                            <i className="bi bi-person-circle d-inline-block d-lg-none me-lg-2" aria-hidden="true"></i>
                                            <span className="d-none d-lg-inline-block d-xl-inline-block d-xxl-inline-block">
                                                <FormattedMessage id="profile" />
                                            </span>
                                        </a>
 
 
                                        <ul className="dropdown-menu">
                                            {/* <li title={formatMessage("store_list")}>
                                                <NavLink to={RoutesConstants.LizeraStoreList}>
                                                    {<FormattedMessage id="store_list" />}
                                                </NavLink>
                                            </li> */}
                                            <li className="pt-2 text-wrap">
                                                {getCustomerNameFromToken()}
                                            </li>
                                            <li><hr /></li>
                                            <li title={formatMessage("reservation")}>
                                                <NavLink to={RoutesConstants.ReservationList}>
                                                    {<FormattedMessage id="reservation" />}
                                                </NavLink>
                                            </li>
 
                                            <li title={formatMessage("booking_management")}>
                                                <NavLink to={RoutesConstants.LizeraStoreList}>
                                                    {<FormattedMessage id="booking_management" />}
                                                </NavLink>
                                            </li>
 
                                            <li title={formatMessage("profile")}>
                                                <NavLink to={RoutesConstants.Profile}>
                                                    {<FormattedMessage id="profile" />}
                                                </NavLink>
                                            </li>
 
                                            <li title={formatMessage("logout")}>
                                                <button type="button" onClick={() => setShowLogoutPopup(true)}>
                                                    {<FormattedMessage id="logout" />}
                                                </button>
                                            </li>
                                        </ul>
                                    </li>
                                ) : (
                                    <li>
                                        <button className="btn btn-primary" onClick={() => {
                                            history.push(RoutesConstants.CustomerLogin);
                                            }}>
                                            <FormattedMessage id="login" />
                                        </button>
                                    </li>
                                )                            
                                }
                            </ul>
                           
                        </div>
                    </div>
                </div>
            </div>
 
        </React.Fragment>
    );
};
 
// Export component wrapped with HOCs and observer
export default injectIntl(observer(CustomerTopNavBar));
